interface Message {
    subject: string;
    data: any;
}

class WS {
    private ws?: WebSocket;
    private listeners = new Array<(msg: Message) => void>();
    public initialized = false;
    private reconnectTimer?: ReturnType<typeof setTimeout>;
    private intentionalClose = false;

    public init(token: string, isChat: boolean = false) {
        this.connect(`${process.env.REACT_APP_WS_API}/${isChat ? "chat" : "user"}/ws/${token}`, () => this.init(token, isChat));
    }

    // Operador: conecta no canal da campanha (não é user-scoped) — recebe os eventos de grupo em tempo real.
    public initOperator(token: string, campaignId: string | number) {
        this.connect(`${process.env.REACT_APP_WS_API}/campaign/${campaignId}/operator/ws/${token}`, () => this.initOperator(token, campaignId));
    }

    private connect(url: string, reconnect: () => void) {
        this.intentionalClose = false;
        this.ws = new WebSocket(url);
        this.initialized = true;
        this.ws.onmessage = ({data}) => this.notify(JSON.parse(data));
        this.ws.onclose = () => {
            if (this.intentionalClose) return;
            this.reconnectTimer = setTimeout(reconnect, 1e3);
        };
    }

    public close() {
        this.intentionalClose = true;
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = undefined;
        }
        if (this.ws) this.ws.close();
        this.initialized = false;
    }

    public subscribe(cb: (msg: Message) => void) {
        this.listeners.push(cb);
        return () => this.unsubscribe(cb);
    }

    public unsubscribe(cb: (msg: Message) => void) {
        this.listeners = this.listeners.filter((l) => l !== cb);
    }

    private notify(msg: Message) {
        this.listeners.forEach((cb) => cb(msg));
    }
}

export default new WS();
